export default class CustomerType{
    id:string;
    name: string;
    pricingTermCode:string;
    creationTime:Date;
    creatorUserName:string;
    pricingTermName:string;
    displayName:string;
}